import { Buttons } from "@/ui/Buttons";
import cn from "classnames";
import { Container, Stack } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-5",
  title,
  description,
  buttons,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.ContentSideButtons)} data-bs-theme={theme}>
      <Container fluid="md" className="border-bottom pb-4 pb-md-3 mb-md-4">
        <Stack className="flex-column flex-md-row gap-3">
          <div>
            <EditableText path="title" tag="h3" className="mb-4">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
            <EditableHtml path="description" className="text-balance">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
          </div>
          <div className="d-flex align-items-center">
            <div>
              <Buttons buttons={buttons} className="flex-row" />
            </div>
          </div>
        </Stack>
      </Container>
    </div>
  );
}
